import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type VwKopfAusrichtung = 'start' | 'ende';

/**
 * Kopf eines Verwaltungsbereichs (Design page-verwaltung.jsx `VwKopf`); trägt das einzige `h1` des Bereichs.
 * Rechts der Standard-Slot, dazu `[vwKopfTitelZusatz]` neben dem Titel und `[vwKopfUntertitel]` mit Markup.
 */
@Component({
  selector: 'app-vw-kopf',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="vw-kopf" [class.vw-kopf--ende]="ausrichtung() === 'ende'">
      <div class="vw-kopf__text">
        <div class="vw-kopf__titelzeile">
          <h1 class="vw-kopf__titel" data-testid="vw-kopf-titel">{{ titel() }}</h1>
          <ng-content select="[vwKopfTitelZusatz]" />
        </div>
        <div class="vw-kopf__untertitel">
          @if (untertitel()) {
            <span>{{ untertitel() }}</span>
          }
          <ng-content select="[vwKopfUntertitel]" />
        </div>
      </div>
      <ng-content />
    </div>
  `,
  styles: `
    :host {
      display: block;
      margin-bottom: var(--vw-kopf-abstand, 1.375rem);
    }

    .vw-kopf {
      display: flex;
      align-items: flex-start;
      flex-wrap: nowrap;
      gap: 1.25rem;

      &--ende {
        align-items: flex-end;
        flex-wrap: wrap;
      }
    }

    .vw-kopf__text {
      flex: 1;
      min-width: 0;
    }

    .vw-kopf__titelzeile {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    .vw-kopf__titel {
      margin: 0;
      font-size: 1.375rem;
      font-weight: 700;
      color: var(--to-accent-deep);
      letter-spacing: -0.02em;
    }

    .vw-kopf__untertitel {
      margin-top: 0.25rem;
      font-size: 0.875rem;
      color: var(--to-text-muted);

      &:empty {
        display: none;
      }
    }
  `,
})
export class VwKopfComponent {
  readonly titel = input.required<string>();
  readonly untertitel = input<string>('');
  readonly ausrichtung = input<VwKopfAusrichtung>('start');
}
